<div class="modal fade"
     id="serviceOrderDetailsModal"
     tabindex="-1"
     role="dialog"
     aria-labelledby="serviceDetailsCenterTitle"
     aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered"
       role="document"
       style="max-width: 80%;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-weight-bold"
            id="serviceDetailsLongTitle">
          {{'Order Details'}}</h5>
        <button type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form (ngSubmit)="completeOrder(form)"
            #form="ngForm">
        <div class="modal-body">
          <h2>{{order.service_name|titlecase}}</h2>
          <div class="row">
            <div class="col">
              <div class="row my-2 py-2">
                <div class="col text-secondary">Package</div>
                <div class="col">{{order.package||"N/A"|titlecase }}</div>
              </div>
              <div class="row my-2 py-2">
                <div class="col text-secondary">{{order.unit|titlecase}}</div>
                <div class="col">{{ 5|number }}</div>
              </div>
              <div class="row my-2 py-2">
                <div class="col text-secondary">Total Cost(UGX)</div>
                <div class="col">{{ order.total_cost }}</div>
              </div>
              <div class="row my-2 py-2">
                <div class="col text-secondary">Payment</div>
                <div class="col">{{ order.payment|uppercase }}</div>
              </div>
              <div class="row my-2 py-2">
                <div class="col text-secondary">Status</div>
                <div class="col">
                  <select class="form-control form-control"
                          id="status"
                          [(ngModel)]="order.status"
                          [disabled]='true'
                          [ngModelOptions]="{standalone: true}">
                    <option [value]="status"
                            *ngFor="let status of statuses">
                      {{status|titlecase}}
                  </select>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card"
                   style="width: 18rem;">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item">
                    Client<span style='float:right'>{{ order.farmer_name }} </span>
                  </li>
                  <li class="list-group-item">
                    District<span style='float:right'>{{ order.farmer_district }} </span>
                  </li>
                  <li class="list-group-item">
                    Parish<span style='float:right'>{{ order.farmer_parish||"N/A"}} </span>
                  </li>
                  <li class="list-group-item">
                    Village<span style='float:right'>{{ order.farmer_village||"N/A" }} </span>
                  </li>
                  <li class="list-group-item">
                    Phone<span style='float:right'>{{ order.farmer_contact||"N/A" }} </span>
                  </li>
                  <ng-container *ngIf="order.type==='map_cordinates'">
                    <li class="list-group-item"
                        *ngIf="order.deviceModel != undefined">
                      Device Model<span style='float:right'>{{ order.deviceModel||"N/A" }} </span>
                    </li>
                    <li class="list-group-item"
                        *ngIf="order.averageAccuracy != undefined">
                      Average Accuracy<span style='float:right'>{{ order.averageAccuracy}} </span>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </div>
            <div class="col"
                 disabled
                 *ngIf="points.length>0">
              <app-google-maps [points]='points'></app-google-maps>
            </div>
          </div>
          <div *ngIf="isSoilTestingOrder">
            <div *ngIf="isNewOrder && order.id"
                 class="row justify-content-between p-4"
                 style="background-color: #EFF0F2;">
              <div class="col-4">
                You haven’t uploaded the soil test results yet
              </div>
              <div class="col-4">
                <div class="input-group mb-3">
                  <div class="results-file">
                    <input type="file"
                           class="results-file-input"
                           accept=".xls,.xlsx"
                           id="results"
                           (change)="soiltestingresults=$event.target.files[0];">
                  </div>
                  <div class="input-group-append">
                    <button class="btn btn-success"
                            type="button"
                            (click)="uploadSoilTestingResults()"
                            [disabled]='(loaders$|async).singleSoilTestOrder'>{{'upload results'|uppercase}}
                      <span *ngIf="(loaders$|async).singleSoilTestOrder"
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="order.status.toLowerCase()==='completed'"
                 class="row p-4"
                 style="background-color: #EFF0F2;">
              <div class="col-4 result-card"
                   *ngIf="order.results_url">
                Soil Test Results.csv
                <div>
                  <span><a>Remove</a></span>
                  <span><a>Download</a></span>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!isSoilTestingOrder">
            <div *ngIf="order.id"
                 class="row justify-content-between p-4"
                 style="background-color: #EFF0F2;">
              <div class="col-4"
                   *ngIf="!order.report">
                You haven’t uploaded the results yet
              </div>
              <div class="col-4"
                   *ngIf="order.report">
                <div class="px-2 reportDownload">
                  <div class="title">
                    <i class="fa fa-paperclip"
                       aria-hidden="true"></i>
                    Report
                  </div>
                  <a class="text-primary"
                     target="_blank"
                     [href]='reportUrl'>Download Report</a>
                </div>
              </div>
              <div class="col-4">
                <div class="input-group mb-3">
                  <div class="results-file">
                    <a class='text-primary text-decoration-underline'
                       appSpinner
                       [isLoading]="(loaders$|async).uploadingResults"
                       (click)="orderResults.click()">
                      Upload Results
                    </a>
                  </div>
                  <input type="file"
                         class="form-control-file d-none"
                         id="orderResults"
                         #orderResults
                         [disabled]="(loaders$|async).uploadingResults"
                         name="orderResults"
                         (change)="uploadOrderResults($event)">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button"
                  class="btn btn-danger"
                  (click)='deleteOrder()'
                  *ngIf="order.id"
                  [disabled]='(loaders$|async).singleOrder'>
            <span *ngIf="(loaders$|async).singleOrder;else textTemplate"
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true">
            </span>
            <ng-template #textTemplate>
              Delete
            </ng-template>
          </button>
          <button type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  [disabled]='(loaders$|async).singleOrder'>Cancel</button>
          <ng-container *ngIf="order.id">
            <ng-container *ngIf="order.type!=='map_cordinates';else submitTemplate">
              <button type="submit"
                      class="btn btn-primary"
                      *ngIf="!isSoilTestingOrder && isNewOrder"
                      [disabled]='(loaders$|async).singleOrder'>
                <span *ngIf="(loaders$|async).singleOrder"
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"></span>
                Complete Order</button>
            </ng-container>
          </ng-container>
        </div>
      </form>
    </div>
  </div>
</div>
